export enum ModalTypeUser {
    NONE = 'none',
    ADD_USER = 'add_user',
    DELETE_USER = 'delete_user',
    UPDATE_USER = 'update_user',
    EDIT_USER = 'edit_user',
    ADD_OWNER = 'add_owner'
} 